/**
 * @desc 根据userNo获取本部门的所有下级部门的员工信息（递归）
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/getAllSubordinate/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
